import React from 'react'
import BbpsScreen2 from '../../consumer/bbps-screen/BBPSScreen'
const BbpsScreen = () => {
    return (
       <BbpsScreen2 discription={false} />
    )
}

export default BbpsScreen
